var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactSupport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.571 1.71423H3.42815C2.48187 1.71423 1.71387 2.48223 1.71387 3.42852V16.2857C1.71387 17.2319 2.48187 17.9999 3.42815 17.9999H8.57101L11.9996 22.2857L15.4282 17.9999H20.571C21.5173 17.9999 22.2853 17.2319 22.2853 16.2857V3.42852C22.2853 2.48223 21.5173 1.71423 20.571 1.71423ZM11.9996 4.28566C13.6539 4.28566 14.9996 5.63138 14.9996 7.28566C14.9996 8.93995 13.6539 10.2857 11.9996 10.2857C10.3453 10.2857 8.99958 8.93995 8.99958 7.28566C8.99958 5.63138 10.3453 4.28566 11.9996 4.28566ZM6.85672 14.9254V15.4285H17.1424V14.9254C17.1424 13.3122 14.8359 11.9999 11.9996 11.9999C9.1633 11.9999 6.85672 13.3122 6.85672 14.9254Z",
    fill: "#111111",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupport);
export default __webpack_public_path__ + "static/media/contact_support.fbeca706b806e90fc5ce70ec78fe7c1f.svg";
export { ForwardRef as ReactComponent };